// @ts-nocheck
export const analyticsEvents = Object.freeze([
  'page_view', 'cta_click', 'form_open', 'form_validation_error', 'form_error', 'form_submit_attempt',
  'form_submit_success', 'form_submit_error', 'solution_view', 'model_view', 'search',
  'filter', 'document_download', 'test_request', 'service_request', 'consumable_request',
  'spare_part_request', 'contact_action',
]);

const forbiddenKeys = new Set([
  'name', 'contactname', 'phone', 'email', 'messenger', 'message', 'serial', 'serialnumber',
  'contract', 'attachmentfilename', 'attachmentcontent', 'technicalspecification', 'address',
  'personalidentifier', 'files', 'attachment', 'password', 'token', 'cookie', 'accesskey',
]);

export function sanitizeAnalyticsPayload(payload = {}) {
  const safe = {};
  for (const [key, value] of Object.entries(payload)) {
    const normalized = key.replace(/[_\-\s]/g, '').toLowerCase();
    if (forbiddenKeys.has(normalized)) continue;
    if (value === null || ['string', 'number', 'boolean'].includes(typeof value)) safe[key] = value;
  }
  return safe;
}

export class AnalyticsAdapter { track(_event, _payload) {} }
export class NoopAnalyticsAdapter extends AnalyticsAdapter { track(_event, _payload) { return { sent: false, code: 'ANALYTICS_DISABLED' }; } }
export class DevelopmentAnalyticsAdapter extends AnalyticsAdapter {
  track(event, payload) {
    if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('anlexx:analytics', { detail: { event, payload } }));
    return { sent: true, code: 'DEVELOPMENT_EVENT' };
  }
}
export class ConsentAwareAnalyticsAdapter extends AnalyticsAdapter {
  constructor(adapter, hasConsent) { super(); this.adapter = adapter; this.hasConsent = hasConsent; }
  track(event, payload) { return this.hasConsent() ? this.adapter.track(event, sanitizeAnalyticsPayload(payload)) : { sent: false, code: 'CONSENT_REQUIRED' }; }
}

const noop = new NoopAnalyticsAdapter();
const development = new DevelopmentAnalyticsAdapter();
const activeAdapter = new ConsentAwareAnalyticsAdapter(import.meta.env.DEV ? development : noop, () => false);

export function track(event, payload = {}) {
  if (!analyticsEvents.includes(event)) throw new Error(`Unknown analytics event: ${event}`);
  return activeAdapter.track(event, sanitizeAnalyticsPayload(payload));
}
